import React from 'react';
import './App.css';


import { Routes, Route } from 'react-router-dom';
import Dmp from './components/Dmp';

function App() {
  return (
    <div className="App">
      
      <Routes>
        <Route path="/" element={<Dmp />} />
        {/* <Route path="/" element={<Dashboard />} />
        <Route path="/projects" element={<ProjectsCard />} />
        <Route path="/project/:id" element={<ProjectDetails />} /> */}
      </Routes>
    </div>
  );
}

export default App;
